(function () {
  'use strict';
  if (window.__uspReihe) return;
  window.__uspReihe = true;

  function setzen(gruppe) {
    document.querySelectorAll('[data-usp]').forEach(function (reihe) {
      var g = gruppe || reihe.getAttribute('data-usp-start');
      reihe.setAttribute('data-gruppe', g);
      reihe.querySelectorAll('[data-usp-in]').forEach(function (p) {
        var liste = ' ' + p.getAttribute('data-usp-in') + ' ';
        p.hidden = liste.indexOf(' ' + g + ' ') < 0;
      });
    });
  }

  document.addEventListener('3idee:usp-gruppe', function (e) {
    setzen(e.detail && e.detail.gruppe ? e.detail.gruppe : null);
  });
})();
